import { csrfToken } from "@circle-react/helpers/csrfToken";

export const CSRFTokenField = () => (
  <input type="hidden" name="authenticity_token" value={csrfToken() ?? ""} />
);
